import * as ordersServices from './ordersServices';

export { ordersServices };
